import { loggingReducer } from './reducers';

export default {
  logging: loggingReducer
};
